import request from '@/utils/request'

// 查询统计数据分页
export function getCategoryPage(query) {
    return request({
        url: '/platform/category/page',
        method: 'get',
        params: query
    })
}

// 更新排序
export function updateCategorySort(data) {
    return request({
        url: '/platform/category/updateSort',
        method: 'post',
        data
    })
}

export function updateCategoryStatus(data) {
    return request.post('/platform/category/updateStatus', data);
}


export function deleteCategory(data) {
    return request.post('/platform/category/delete', data);
}
